export default "__VITE_ASSET__CFq9cXvj__"